// Audit 07 / F-82 — canonical Contact entity (current operational truth for
// a person's relationship with a Client). A Contact belongs to exactly one
// Client; `client` is the ownership boundary.
export type ContactRole = 'PRIMARY' | 'SIGNATORY' | 'BILLING' | 'OPERATIONAL';

export const CONTACT_ROLES: ContactRole[] = ['PRIMARY', 'SIGNATORY', 'BILLING', 'OPERATIONAL'];

export interface Contact {
  _id: string;
  client: string;
  name: string;
  position?: string;
  email?: string;
  phone?: string;
  roles: ContactRole[];
  properties: string[];
  isActive: boolean;
  archivedAt?: string;
  archivedBy?: string;
  createdBy?: string;
  migratedFrom?: 'client-owner' | 'property';
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateContactDTO {
  clientId: string;
  name: string;
  position?: string;
  email?: string;
  phone?: string;
  roles?: ContactRole[];
  properties?: string[];
}

export interface UpdateContactDTO {
  name?: string;
  position?: string;
  email?: string;
  phone?: string;
  roles?: ContactRole[];
  properties?: string[];
}
